export const SET_ADMIN_USERS = 'SET_ADMIN_USERS';
export const SET_SPECIAL_USERS = 'SET_SPECIAL_USERS';
export const SUBMITTING_NEW_ADMIN = 'SUBMITTING_NEW_ADMIN';
export const REVOKING_ADMIN = 'REVOKING_ADMIN';
export const SUBMITTING_NEW_SPECIAL_USER = 'SUBMITTING_NEW_SPECIAL_USER';
export const REVOKING_SPECIAL_USER = 'REVOKING_SPECIAL_USER';
export const SET_COURSE_CREATION_SETTINGS = 'SET_COURSE_CREATION_SETTINGS';
export const SET_FEATURED_CAMPAIGNS = 'SET_FEATURED_CAMPAIGNS';
export const REMOVE_FEATURED_CAMPAIGN = 'REMOVE_FEATURED_CAMPAIGN';
export const ADD_FEATURED_CAMPAIGN = 'ADD_FEATURED_CAMPAIGN';
export const SET_DEFAULT_CAMPAIGN = 'SET_DEFAULT_CAMPAIGN';
export const SET_SITE_NOTICE = 'SET_SITE_NOTICE';
